import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { Subscription } from "rxjs";
import { DetalleEstablecimientoService } from "../establecimiento/establecimiento.service";
import { FonturService } from "../../../prestador/pasos/fontur/fontur.service";
import { CompletaInformacionService } from "../../../prestador/pasos/completa-informacion/completa-informacion.service";
import { isNull } from "util";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { AuthService } from "src/app/shared/services/auth.service";

@Component({
  selector: "app-fontur-funcionario",
  templateUrl: "./fontur.component.html",
  styleUrls: ["./fontur.component.scss"],
})
export class FonturFuncionarioComponent implements OnInit {
  @Output()
  pasoActual: EventEmitter<number> = new EventEmitter();

  datoSolicitudSharedModel: DatoSolicitudSharedModel;
  rnt: RNTPrestadorEntry;
  subscription: Subscription;
  validacionFontur = 2;
  mensajeFontur: string;
  informacionEstablecimiento: any;
  tipo_funcionario = RolesUsuario.Funcionario;

  constructor(
    private dataSharedService: DataSharedService,
    private detalleEstablecimientoService: DetalleEstablecimientoService,
    private fonturService: FonturService,
    private completaInformacionService: CompletaInformacionService,
    public authService: AuthService
  ) {
    this.subscription = this.dataSharedService.data$.subscribe((dataShared) => {
      this.datoSolicitudSharedModel = dataShared as DatoSolicitudSharedModel;
    });
    this.informacionEstablecimiento = {};
  }

  ngOnInit() {
    this.detalleEstablecimientoService
      .getDetalleEstablecimiento(this.datoSolicitudSharedModel.data)
      .subscribe((res) => {
        if (res.result) {
          this.informacionEstablecimiento = res.data;
          this.validacionFontur = isNull(
            this.informacionEstablecimiento.supera_validacion_fontur
          )
            ? 1
            : this.informacionEstablecimiento.supera_validacion_fontur
            ? 0
            : 2;
        }
      });
  }

  reValidarFontur() {
    this.fonturService
      .get(this.informacionEstablecimiento)
      .subscribe((resultado) => {
        if (resultado.result) {
          this.fonturService
            .update({ ...this.informacionEstablecimiento, ...resultado.data })
            .subscribe((res) => {
              if (res.result) {
                this.informacionEstablecimiento = {
                  ...this.informacionEstablecimiento,
                  ...resultado.data,
                };
                this.validacionFontur = isNull(
                  this.informacionEstablecimiento.supera_validacion_fontur
                )
                  ? 1
                  : this.informacionEstablecimiento.supera_validacion_fontur
                  ? 0
                  : 2;
              }
            });
        }
      });
  }

  reditarMensaje(mensaje: string): string {
    let sentencia = "";

    let Mensajarr = mensaje.split("</br>");

    if (Mensajarr.length > 1) {
      sentencia = Mensajarr[1].toString();
    } else {
      sentencia = mensaje;
    }

    return sentencia;
  }
}
